import React from "react";
import SmartRtpTablePage from "./components/SmartRtpTablePage";
import { getAuditLogs } from "../../../controllers/V1/smartRtp/smartRtpController";

export default function SmartRtpAuditLogsPage() {
  return (
    <SmartRtpTablePage
      title="Smart RTP Audit Logs"
      activeKey="audit-logs"
      fetchData={getAuditLogs}
      statusTabs={[
        { label: "All", value: "" },
        { label: "Create", value: "CREATE" },
        { label: "Update", value: "UPDATE" },
        { label: "Delete", value: "DELETE" },
        { label: "Status Change", value: "STATUS_CHANGE" },
      ]}
      statusField="action"
      searchFields={["entity_type", "admin_email", "correlation_id", "action"]}
      exportFileName="Smart RTP Audit Logs"
      columns={[
        { key: "action", label: "Action" },
        { key: "entity_type", label: "Entity Type" },
        { key: "admin_email", label: "Admin Email" },
        { key: "reason", label: "Reason" },
        { key: "correlation_id", label: "Correlation Id" },
        { key: "createdAt", label: "Created At" },
      ]}
    />
  );
}
